import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { SidebarDealershipsContainerProps } from "../../../../interfaces/containers";
import Sidebar from "../../../../pages/Profile/Concessionaire/Sidebar/Sidebar";
import { 
    getDealerships, 
    cleanGetDealerships, 
    addDealership, 
    cleanAddDealership, 
    editDealership, 
    cleanEditDealership, 
    deleteDealership, 
    cleanDeleteDealership,
} from "../../../../actions/dealerships";
import {
    getRegions,
    getCities,
    getCommunes,
} from "../../../../actions/profile";
import {
    postUserImage,
    cleanPostImage,
} from "../../../../actions/auth";

interface SidebarWrapperProps {
    user: any;
    dealerships: any;
    regions: any;
    cities: any;
    communes: any;
    getDealerships: Function;
    cleanGetDealerships: Function;
    addDealership: Function;
    cleanAddDealership: Function;
    editDealership: Function;
    cleanEditDealership: Function;
    deleteDealership: Function;
    cleanDeleteDealership: Function;
    getRegions: Function;
    getCities: Function;
    getCommunes: Function;
    dealershipsImage: any;
    postUserImage: Function;
    cleanPostImage: Function;
    token: string;
    state: any;
    setState: Function;
    dealershipSelected: any;
}

const SidebarWrapper = (props: SidebarWrapperProps) => {
    return <Sidebar {...props} />;
};

function mapStateToProps(state: SidebarDealershipsContainerProps) {
    return {
        user: state.auth.user,
        dealerships: state.profile.dealerships,
        regions: state.profile.regions,
        cities: state.profile.cities,
        communes: state.profile.communes,
        dealershipsImage: state.profile.postImage || null,
        token: state.auth.token || ''
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getDealerships,
        cleanGetDealerships,
        addDealership, 
        cleanAddDealership, 
        editDealership, 
        cleanEditDealership, 
        deleteDealership, 
        cleanDeleteDealership,
        getRegions,
        getCities,
        getCommunes,
        postUserImage,
        cleanPostImage,
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarWrapper);